import { render, staticRenderFns } from "./product-details-assets.vue?vue&type=template&id=b04392ba&scoped=true&"
import script from "./product-details-assets.vue?vue&type=script&lang=js&"
export * from "./product-details-assets.vue?vue&type=script&lang=js&"
import style0 from "./product-details-assets.vue?vue&type=style&index=0&id=b04392ba&scoped=true&lang=scss&"
import style1 from "./product-details-assets.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04392ba",
  null
  
)

export default component.exports